/**
 * 基础路由
 * @type { *[] }
 */
export const asyncRouterMap = [
  {
    path: '/', 
    redirect: '/index',
    meta: { 
      navIndex: 0,
      navList:[]
    }
  },
  // {
  //   path: '/index', 
  //   name: 'index',
  //   component:()=>import('@views/index'),
  //   meta: { title: '汉阴政协网站' }
  // },
  {
    path: '/About',
    name: 'About',
    component: () => import ('@/components/page/GlobalLayout.vue'),
    children:[
      {
        path: '/index', 
        name: 'index',
        component:()=>import('@views/home/index'),
        meta: { navIndex: 0 }
      },
      {
        path: '/gzdt', 
        name: 'gzdt',
        component:()=>import('@views/home/gzdt'),
        meta: { navIndex: 1 }
      },
      {
        path: '/gsgg', 
        name: 'gsgg',
        component:()=>import('@views/home/gsgg'),
        meta: { navIndex: 2 }
      },
      {
        path: '/jgsz', 
        name: 'jgsz',
        component:()=>import('@views/home/jgsz'),
        meta: { navIndex: 3 }
      },
      {
        path: '/wyzx', 
        name: 'wyzx',
        component:()=>import('@views/home/wyzx'),
        meta: { navIndex: 4 }
      },
      {
        path: '/sqmy', 
        name: 'sqmy',
        component:()=>import('@views/home/sqmy'),
        meta: { navIndex: 5 }
      },
      {
        path: '/tagz', 
        name: 'tagz',
        component:()=>import('@views/home/tagz'),
        meta: { navIndex: 6 }
      },
      {
        path: '/wszl', 
        name: 'wszl',
        component:()=>import('@views/home/wszl'),
        meta: { navIndex: 7 }
      },
      {
        path: '/dyfc', 
        name: 'dyfc',
        component:()=>import('@views/home/dyfc'),
        meta: { navIndex: 8 }
      },
      {
        path: '/Ztjyzl', 
        name: 'Ztjyzl',
        component:()=>import('@views/home/Ztjyzl'),
        meta: { navIndex: 9 }
      },
      {
        path: '/searchFrom', 
        name: 'searchFrom',
        component:()=>import('@views/home/searchFrom'),
        meta: { navIndex: 10 }
      },
      {
        path: '/viewSearch', 
        name: 'viewSearch',
        component:()=>import('@views/home/viewSearch'),
        meta: { navIndex: 10 }
      },
      {
        path: '/pdfView', 
        name: 'pdfView',
        component:()=>import('@views/home/pdfView'),
        meta: { navIndex: 10 }
      },
    ]
  },
  {
    path: '/success', 
    name: 'success',
    component:()=>import('@views/success'),
    meta: { title: '提交结果' }
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@views/404')
  },

]
